// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { fuse as _fuse } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the fuse chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 122
 * Chain Name: Fuse
 * Default Block Explorer: https://explorer.fuse.io
 * Default RPC URL: https://rpc.fuse.io
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { fuse } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: fuse,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const fuse = createCommon({
	..._fuse,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
